import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './web-page.reducer';

export const WebPageDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const webPageEntity = useAppSelector(state => state.webPage.entity);
  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 4, p: 2 }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 8 }}>
          <Typography variant="h4" component="h2">
            <Translate contentKey="jhipsterSampleApplicationApp.webPage.detail.title">WebPage</Translate>
          </Typography>
          <Box sx={{ mt: 3 }}>
            <Typography variant="subtitle1">
              <Translate contentKey="global.field.id">ID</Translate>: {webPageEntity.id}
            </Typography>
            <Typography variant="subtitle1">
              <Translate contentKey="jhipsterSampleApplicationApp.webPage.code">Code</Translate>: {webPageEntity.code}
            </Typography>
            <Typography variant="subtitle1">
              <Translate contentKey="jhipsterSampleApplicationApp.webPage.enabled">Enabled</Translate>:{' '}
              {webPageEntity.enabled ? 'true' : 'false'}
            </Typography>
            <Typography variant="subtitle1">
              <Translate contentKey="jhipsterSampleApplicationApp.webPage.uriPath">Uri Path</Translate>: {webPageEntity.uriPath}
            </Typography>
            <Typography variant="subtitle1">
              <Translate contentKey="jhipsterSampleApplicationApp.webPage.publishDate">Publish Date</Translate>:{' '}
              {webPageEntity.publishDate ? (
                <TextFormat value={webPageEntity.publishDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
              ) : null}
            </Typography>
            <Typography variant="subtitle1">
              <Translate contentKey="jhipsterSampleApplicationApp.webPage.createdDate">Created Date</Translate>:{' '}
              {webPageEntity.createdDate ? (
                <TextFormat value={webPageEntity.createdDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
              ) : null}
            </Typography>
            <Typography variant="subtitle1">
              <Translate contentKey="jhipsterSampleApplicationApp.webPage.createdBy">Created By</Translate>:{' '}
              {webPageEntity.createdBy ? webPageEntity.createdBy.login : ''}
            </Typography>
            <Typography variant="subtitle1">
              <Translate contentKey="jhipsterSampleApplicationApp.webPage.tags">Tags</Translate>:{' '}
              {webPageEntity.tags
                ? webPageEntity.tags.map((val, i) => (
                    <span key={val.id}>
                      <a>{val.code}</a>
                      {webPageEntity.tags && i === webPageEntity.tags.length - 1 ? '' : ', '}
                    </span>
                  ))
                : null}
            </Typography>
          </Box>
          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button component={Link} to="/web-page" replace color="info" variant="outlined" data-cy="entityDetailsBackButton">
              <FontAwesomeIcon icon="arrow-left" />
              <Translate contentKey="entity.action.back">Back</Translate>
            </Button>
            <Button component={Link} to={`/web-page/${webPageEntity.id}/edit`} replace color="primary" variant="contained">
              <FontAwesomeIcon icon="pencil-alt" />
              <Translate contentKey="entity.action.edit">Edit</Translate>
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default WebPageDetail;
